import { __assign, __rest } from "tslib";
import React from 'react';
import { DialogTitle, makeStyles, Typography, } from '@material-ui/core';
import { FlexBox } from '../Flex/FlexBox';
var useModalContentStyles = makeStyles(function (theme) { return ({
    root: {
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        flexDirection: 'column',
        outline: 0,
        alignItems: 'stretch',
        borderRadius: '4px',
    },
    body: {
        padding: theme.spacing(5, 10, 4, 10),
        maxWidth: '100%',
    },
}); });
export var ModalContent = function (props) {
    var styles = useModalContentStyles();
    return React.createElement("div", { className: styles.root }, props.children);
};
export var ModalBody = function (props) {
    var classes = useModalContentStyles();
    return React.createElement("div", { className: classes.body }, props.children);
};
var useModalHeaderStyles = makeStyles(function (theme) { return ({
    root: {
        right: 0,
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(2, 1),
        textAlign: 'center',
        color: theme.palette.secondary.light,
    },
}); });
export var ModalHeader = function (_a) {
    var children = _a.children, other = __rest(_a, ["children"]);
    var styles = useModalHeaderStyles();
    return (React.createElement(DialogTitle, __assign({ disableTypography: true, className: styles.root }, other), children));
};
var useModalHeaderActionStyles = makeStyles(function () { return ({
    root: {
        border: 'none',
        cursor: 'pointer',
        backgroundColor: 'inherit',
    },
}); });
export var ModalHeaderAction = function (props) {
    var children = props.children, other = __rest(props, ["children"]);
    var styles = useModalHeaderActionStyles();
    return (React.createElement("button", __assign({ "data-e2e-component": "modal-header-action", className: styles.root }, other), children));
};
export var useDialogStyles = makeStyles(function () { return ({
    root: {
        maxWidth: '624px',
    },
}); });
export var ModalTitle = function (_a) {
    var children = _a.children;
    return (React.createElement(FlexBox, { marginBottom: 1 },
        React.createElement(Typography, { variant: "h4" }, children)));
};
export var ModalSubtitle = function (_a) {
    var children = _a.children;
    return (React.createElement(FlexBox, { display: "flex", marginBottom: 2 },
        React.createElement(Typography, { variant: "body1" }, children)));
};
//# sourceMappingURL=Modal.styled.js.map